(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
  class YGImageWithTextProductsController extends HTMLElement {
    constructor() {
      super();
      this.animationFrame = null;
      this.swiper = null;
      this.handleSlideChange = this.updateController.bind(this);
    }

    connectedCallback() {
      this.$current = this.querySelector('[data-current]');
      this.$previousButton = this.querySelector('.swiper-button-prev');
      this.$nextButton = this.querySelector('.swiper-button-next');
      this.connectSwiper();
    }

    disconnectedCallback() {
      if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
      }

      if (this.swiper) {
        this.swiper.off('slideChange', this.handleSlideChange);
      }

      this.swiper = null;
    }

    connectSwiper() {
      const $products = this.closest('.image-with-text__products');
      const $swiper = $products?.querySelector('yg-swiper');

      if (!$swiper?.swiper) {
        this.animationFrame = requestAnimationFrame(() => this.connectSwiper());
        return;
      }

      this.swiper = $swiper.swiper;
      this.swiper.on('slideChange', this.handleSlideChange);
      this.updateController();
    }

    updateController() {
      const currentIndex = this.swiper.realIndex + 1;

      this.$current.textContent = String(currentIndex).padStart(2, '0');
      this.setButtonState(this.$previousButton, this.swiper.isBeginning);
      this.setButtonState(this.$nextButton, this.swiper.isEnd);
    }

    setButtonState($button, isDisabled) {
      $button.disabled = isDisabled;
      $button.setAttribute('aria-disabled', String(isDisabled));
    }
  }

  if (!window.customElements.get('yg-image-with-text-products-controller')) {
    window.customElements.define('yg-image-with-text-products-controller', YGImageWithTextProductsController);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
  class YGRichTextCollapse extends HTMLElement {
    constructor() {
      super();

      this.animationFrame = null;
      this.lastWidth = 0;
      this.handleToggle = this.handleToggle.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      if (this.isInitialized) {
        return;
      }

      this.$content = this.querySelector('[data-collapse-content]');
      this.$toggle = this.querySelector('[data-collapse-toggle]');
      this.$expandLabel = this.querySelector('[data-expand-label]');
      this.$collapseLabel = this.querySelector('[data-collapse-label]');

      if (!this.$content || !this.$toggle) {
        return;
      }

      this.isInitialized = true;
      this.lastWidth = this.getBoundingClientRect().width;
      this.$toggle.addEventListener('click', this.handleToggle);

      this.resizeObserver = new ResizeObserver(this.handleResize);
      this.resizeObserver.observe(this);

      if (document.fonts?.ready) {
        document.fonts.ready.then(() => this.scheduleOverflowCheck());
      }

      this.scheduleOverflowCheck();
    }

    disconnectedCallback() {
      if (!this.isInitialized) {
        return;
      }

      this.$toggle.removeEventListener('click', this.handleToggle);
      this.resizeObserver?.disconnect();

      if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
      }

      this.animationFrame = null;
      this.isInitialized = false;
    }

    handleToggle() {
      const isExpanded = this.$toggle.getAttribute('aria-expanded') === 'true';

      this.setExpanded(!isExpanded);
    }

    handleResize(entries) {
      const currentWidth = entries[0]?.contentRect.width ?? this.getBoundingClientRect().width;

      if (Math.abs(currentWidth - this.lastWidth) < 1) {
        return;
      }

      this.lastWidth = currentWidth;
      this.scheduleOverflowCheck();
    }

    scheduleOverflowCheck() {
      if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
      }

      this.animationFrame = requestAnimationFrame(() => {
        this.animationFrame = null;
        this.updateOverflowState();
      });
    }

    updateOverflowState() {
      const wasExpanded = this.$toggle.getAttribute('aria-expanded') === 'true';

      this.$content.classList.add('yg-line-clamp');

      const hasOverflow = this.$content.scrollHeight > this.$content.clientHeight + 1;

      this.$toggle.hidden = !hasOverflow;

      if (!hasOverflow) {
        this.setExpanded(false, false);
        this.$content.classList.remove('yg-line-clamp');
        return;
      }

      this.setExpanded(wasExpanded, false);
    }

    setExpanded(isExpanded, shouldFocus = true) {
      this.$content.classList.toggle('yg-line-clamp', !isExpanded);
      this.$toggle.setAttribute('aria-expanded', String(isExpanded));

      if (this.$expandLabel) {
        this.$expandLabel.hidden = isExpanded;
      }

      if (this.$collapseLabel) {
        this.$collapseLabel.hidden = !isExpanded;
      }

      if (shouldFocus) {
        this.$toggle.focus({ preventScroll: true });
      }
    }
  }

  if (!window.customElements.get('yg-rich-text-collapse')) {
    window.customElements.define('yg-rich-text-collapse', YGRichTextCollapse);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-image-dot-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('yg-image-dot-product')) {
      return;
    }

    class YGImageDotProduct extends HTMLElement {
      connectedCallback() {
        this.handleResize = () => this.positionActiveCards();

        this.addEventListener('click', (event) => {
          const previousButton = event.target.closest('[data-yg-image-dot-prev]');
          const nextButton = event.target.closest('[data-yg-image-dot-next]');

          if (previousButton || nextButton) {
            const control = previousButton || nextButton;
            const carousel = control.closest('[data-yg-image-dot-carousel]');
            this.changeSlide(carousel, previousButton ? -1 : 1);
            return;
          }

          const trigger = event.target.closest('[data-yg-image-dot-trigger]');

          if (!trigger || !this.contains(trigger)) {
            return;
          }

          const activeGroup = trigger.closest('[data-yg-image-dot-group]');
          const activeSlide = activeGroup.closest('[data-yg-image-dot-slide]');
          const groups = activeSlide.querySelectorAll('[data-yg-image-dot-group]');
          const shouldCloseActiveGroup = activeGroup.classList.contains('is-active');

          groups.forEach((group) => {
            const shouldOpenGroup = group === activeGroup && !shouldCloseActiveGroup;
            group.classList.toggle('is-active', shouldOpenGroup);

            const card = group.querySelector('[data-yg-image-dot-card]');
            if (card && !shouldOpenGroup) {
              card.style.removeProperty('--yg-image-dot-card-offset-x');
            }

            const groupTrigger = group.querySelector('[data-yg-image-dot-trigger]');
            if (groupTrigger) {
              groupTrigger.setAttribute('aria-expanded', shouldOpenGroup ? 'true' : 'false');
            }
          });

          this.positionActiveCards();
        });

        window.addEventListener('resize', this.handleResize);
        this.bindCarousels();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
      }

      bindCarousels(retryCount = 0) {
        const carousels = this.getCarousels();
        let hasPendingSwiper = false;

        carousels.forEach((carousel) => {
          const swiper = carousel.swiper;

          if (!swiper) {
            hasPendingSwiper = true;
            return;
          }

          if (carousel.dataset.ygImageDotBound === 'true') {
            return;
          }

          carousel.dataset.ygImageDotBound = 'true';
          swiper.update();
          swiper.on('slideChange', () => this.syncCarouselState(carousel));
          this.syncCarouselState(carousel);
        });

        if (hasPendingSwiper && retryCount < 20) {
          window.setTimeout(() => this.bindCarousels(retryCount + 1), 50);
        }
      }

      getCarousels() {
        return Array.from(this.querySelectorAll('[data-yg-image-dot-carousel]'));
      }

      getSlides(carousel) {
        if (!carousel) {
          return [];
        }

        return Array.from(carousel.querySelectorAll('[data-yg-image-dot-slide]'));
      }

      changeSlide(carousel, direction) {
        if (!carousel) {
          return;
        }

        const swiper = carousel.swiper;
        const slides = this.getSlides(carousel);

        if (slides.length < 2) {
          return;
        }

        const currentIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
        const nextIndex = (Math.max(currentIndex, 0) + direction + slides.length) % slides.length;

        if (swiper) {
          swiper.update();
          swiper.slideTo(nextIndex);
          return;
        }

        this.setActiveSlide(carousel, slides[nextIndex]);
        this.updateCounter(carousel, nextIndex);
      }

      syncCarouselState(carousel) {
        const slides = this.getSlides(carousel);

        if (slides.length === 0) {
          return;
        }

        const swiper = carousel.swiper;
        if (swiper) {
          swiper.update();
        }

        const activeIndex = swiper ? swiper.activeIndex : Math.max(slides.findIndex((slide) => slide.classList.contains('is-active')), 0);
        const activeSlide = slides[Math.min(Math.max(activeIndex, 0), slides.length - 1)] || slides[0];

        this.setActiveSlide(carousel, activeSlide);
        this.updateCounter(carousel, slides.indexOf(activeSlide));
        this.positionActiveCards();
      }

      setActiveSlide(carousel, activeSlide) {
        this.getSlides(carousel).forEach((slide) => {
          slide.classList.toggle('is-active', slide === activeSlide);
          this.closeGroups(slide);
        });
      }

      closeGroups(slide) {
        slide.querySelectorAll('[data-yg-image-dot-group]').forEach((group) => {
          group.classList.remove('is-active');

          const card = group.querySelector('[data-yg-image-dot-card]');
          if (card) {
            card.style.removeProperty('--yg-image-dot-card-offset-x');
          }

          const trigger = group.querySelector('[data-yg-image-dot-trigger]');
          if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
          }
        });
      }

      positionActiveCards() {
        if (!window.matchMedia('(max-width: 699px)').matches) {
          this.querySelectorAll('[data-yg-image-dot-card]').forEach((card) => {
            card.style.removeProperty('--yg-image-dot-card-offset-x');
          });
          return;
        }

        window.requestAnimationFrame(() => {
          const activeGroups = this.querySelectorAll('[data-yg-image-dot-group].is-active');

          activeGroups.forEach((group) => {
            const card = group.querySelector('[data-yg-image-dot-card]');
            if (!card) {
              return;
            }

            card.style.setProperty('--yg-image-dot-card-offset-x', '0px');

            const viewportPadding = 16;
            const cardRect = card.getBoundingClientRect();
            const minLeft = viewportPadding;
            const maxRight = window.innerWidth - viewportPadding;
            let offsetX = 0;

            if (cardRect.left < minLeft) {
              offsetX = minLeft - cardRect.left;
            } else if (cardRect.right > maxRight) {
              offsetX = maxRight - cardRect.right;
            }

            card.style.setProperty('--yg-image-dot-card-offset-x', Math.round(offsetX) + 'px');
          });
        });
      }

      updateCounter(carousel, index) {
        const counter = carousel.querySelector('[data-yg-image-dot-counter]');

        if (!counter) {
          return;
        }

        const slides = this.getSlides(carousel);
        const currentCounter = counter.querySelector('[data-yg-image-dot-current]');
        const totalCounter = counter.querySelector('[data-yg-image-dot-total]');

        if (currentCounter) {
          currentCounter.textContent = String(Math.max(index + 1, 1));
        }

        if (totalCounter) {
          totalCounter.textContent = String(slides.length);
        }
      }
    }

    customElements.define('yg-image-dot-product', YGImageDotProduct);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-image-with-text"] && !Shopify.designMode) return;
  try {
    
  class YGImageWithText extends HTMLElement {
    constructor() {
      super();
      this.activeIndex = 0;
      this.handleClick = this.handleClick.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
    }

    connectedCallback() {
      if (this.isInitialized) {
        return;
      }

      this.isInitialized = true;
      this.$looks = Array.from(this.querySelectorAll('[data-look]'));
      this.activeIndex = this.getInitialIndex();
      this.addEventListener('click', this.handleClick);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
      this.updateLooks();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.isInitialized = false;
    }

    getInitialIndex() {
      const activeIndex = this.$looks.findIndex(($look) => $look.classList.contains('is-active'));
      return activeIndex >= 0 ? activeIndex : 0;
    }

    handleClick(event) {
      const $button = event.target.closest('[data-look-navigation]');

      if (!$button || !this.contains($button) || $button.disabled) {
        return;
      }

      const nextIndex = $button.dataset.lookNavigation === 'previous' ? this.activeIndex - 1 : this.activeIndex + 1;
      this.selectLook(nextIndex);
    }

    handleBlockSelect(event) {
      const $look = event.target.closest('[data-look]');

      if (!$look || !this.contains($look)) {
        return;
      }

      this.selectLook(this.$looks.indexOf($look));
    }

    selectLook(index) {
      const nextIndex = Math.max(0, Math.min(index, this.$looks.length - 1));

      if (nextIndex === this.activeIndex) {
        this.updateNavigation();
        return;
      }

      this.activeIndex = nextIndex;
      this.dataset.activeIndex = String(nextIndex);
      this.updateLooks();
    }

    updateLooks() {
      this.$looks.forEach(($look, index) => {
        const isActive = index === this.activeIndex;
        $look.classList.toggle('is-active', isActive);
        $look.setAttribute('aria-hidden', String(!isActive));

        if (isActive) {
          $look.removeAttribute('inert');
        } else {
          $look.setAttribute('inert', '');
        }
      });

      this.updateNavigation();
    }

    updateNavigation() {
      const currentLook = String(this.activeIndex + 1).padStart(2, '0');
      const isFirst = this.activeIndex === 0;
      const isLast = this.activeIndex === this.$looks.length - 1;

      this.querySelectorAll('[data-current]').forEach(($current) => {
        $current.textContent = currentLook;
      });

      this.querySelectorAll('[data-look-navigation="previous"]').forEach(($button) => {
        this.setButtonState($button, isFirst);
      });

      this.querySelectorAll('[data-look-navigation="next"]').forEach(($button) => {
        this.setButtonState($button, isLast);
      });
    }

    setButtonState($button, isDisabled) {
      $button.disabled = isDisabled;
      $button.setAttribute('aria-disabled', String(isDisabled));
    }
  }

  if (!window.customElements.get('yg-image-with-text')) {
    window.customElements.define('yg-image-with-text', YGImageWithText);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-card-swiper"] && !Shopify.designMode) return;
  try {
    
  class YGProductCardSwiper extends HTMLElement {
    constructor() {
      super();
      this.handleTabClick = this.handleTabClick.bind(this);
    }

    connectedCallback() {
      if (this.isInitialized) return;

      this.isInitialized = true;
      this.addEventListener('click', this.handleTabClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleTabClick);
      this.isInitialized = false;
    }

    handleTabClick(event) {
      const $tabTitle = event.target.closest('.tab-title');
      if (!$tabTitle || !this.contains($tabTitle)) return;

      window.requestAnimationFrame(() => {
        this.updateViewAllLink($tabTitle.dataset.collectionUrl || '');
        this.updateActiveSwiper();
      });
    }

    updateViewAllLink(collectionUrl) {
      const $viewAllLink = this.querySelector('[data-view-all-link]');
      if (!$viewAllLink) return;

      if (collectionUrl) {
        $viewAllLink.href = collectionUrl;
        $viewAllLink.removeAttribute('role');
        $viewAllLink.removeAttribute('aria-disabled');
        return;
      }

      $viewAllLink.removeAttribute('href');
      $viewAllLink.setAttribute('role', 'link');
      $viewAllLink.setAttribute('aria-disabled', 'true');
    }

    updateActiveSwiper() {
      const $activePanel = this.querySelector('yg-tabs-content > .tab-content.is-active');
      const $swiper = $activePanel?.querySelector('yg-swiper');
      $swiper?.swiper?.update();
    }
  }

  if (!window.customElements.get('yg-product-card-swiper')) {
    window.customElements.define('yg-product-card-swiper', YGProductCardSwiper);
  }

  } catch(e) { console.error(e); }
})();
})();
